export default __webpack_public_path__ + "static/media/3147.bc7257dd.jpg";